/* Definitions of actions coming from the cluster (hooked as events from the websocket) */
export const VISITOR_AUTH_SUCCESS = 'from-cluster/VISITOR_AUTH_SUCCESS';
export const VISITOR_AUTH_FAILED = 'from-cluster/VISITOR_AUTH_FAILED';
export const VISITOR_SEND_MESSAGE = 'from-cluster/VISITOR_SEND_MESSAGE';

export const CONTINUE_CHAT = 'from-cluster/CONTINUE_CHAT';
export const SEND_INITIAL_MESSAGES_TO_CLIENT = 'from-cluster/SEND_INITIAL_MESSAGES_TO_CLIENT';
export const CHAT_ASSIGNED = 'from-cluster/CHAT_ASSIGNED';
export const CHAT_NOT_EXISTS = 'from-cluster/CHAT_NOT_EXISTS';
export const CHAT_CLOSED_BY_OPERATOR = 'from-cluster/CHAT_CLOSED_BY_OPERATOR';
export const CHAT_CLOSED_BY_ADMIN = 'from-cluster/CHAT_CLOSED_BY_ADMIN';
export const CHAT_DECLINE_BY_OPERATOR = 'from-cluster/CHAT_DECLINE_BY_OPERATOR';

export const OPERATOR_TYPING = 'from-cluster/OPERATOR_TYPING';
export const OPERATOR_SEND_MESSAGE = 'from-cluster/OPERATOR_SEND_MESSAGE';
export const OPERATOR_SEND_TRANSLATE_MESSAGE = 'from-cluster/OPERATOR_SEND_TRANSLATE_MESSAGE';

export const TRANSFER_START = 'from-cluster/TRANSFER_START';
export const TRANSFER_COMPLETED = 'from-cluster/TRANSFER_COMPLETED';

export const USER_SUBMITTED_CHAT_RATING = 'from-cluster/USER_SUBMITTED_CHAT_RATING';

export const visitorAuthSuccess = ({ sessionId, visitorToken }) => ({
  type: VISITOR_AUTH_SUCCESS,
  payload: {
    sessionId,
    visitorToken
  }
});

export const visitorAuthFailed = (payload = {}) => ({ type: VISITOR_AUTH_FAILED, payload: { ...payload } });

export const chatAssigned = ({ operator, operator_id, request_id, visitor_id }) => ({
  type: CHAT_ASSIGNED,
  payload: {
    operator,
    operator_id,
    request_id,
    visitor_id
  }
});

export const operatorSendMessage = (payload) => ({
  type: OPERATOR_SEND_MESSAGE,
  payload
});

export const visitorSendMessage = (payload) => ({
  type: VISITOR_SEND_MESSAGE,
  payload
});

export const operatorIsTyping = (payload) => ({
  type: OPERATOR_TYPING,
  payload
});
export const operatorSendTranslatedMessage = (payload) => ({
  type: OPERATOR_SEND_TRANSLATE_MESSAGE,
  payload
});

/**
 * @param {{reason: string, userId: number, visitorId: number}} payload
 * @returns {{payload: {reason: string, userId: number, visitorId: number}, type: string}}
 */
export const chatNotExists = ({ visitorId, userId, reason }) => ({
  type: CHAT_NOT_EXISTS,
  payload: {
    visitorId,
    userId,
    reason
  }
});

export const chatClosedByOperator = () => ({ type: CHAT_CLOSED_BY_OPERATOR });
export const chatClosedByAdmin = () => ({ type: CHAT_CLOSED_BY_ADMIN });

export const transferCompleted = (payload) => ({ type: TRANSFER_COMPLETED, payload });

export const continueChat = ({
  status,
  currentOperatorId = null,
  messages = [],
  operators = {},
  requestId,
  languages = []
}) => ({
  type: CONTINUE_CHAT,
  payload: {
    status,
    currentOperatorId,
    messages,
    operators,
    requestId,
    languages
  }
});

export const sendInitialChatMessagesToClient = ({
  currentOperatorId = null,
  messages = [],
  operators = {},
  languages = []
}) => ({
  type: SEND_INITIAL_MESSAGES_TO_CLIENT,
  payload: {
    currentOperatorId,
    messages,
    operators,
    languages
  }
});

export const userSubmittedChatRating = () => ({ type: USER_SUBMITTED_CHAT_RATING });
